import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Pos } from '../../../../../core/models/pos.model';
import { PosService } from '../../services/pos.service';
import { ToastrService } from 'ngx-toastr';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-switch-pos-order',
  templateUrl: './switch-pos-order.component.html',
  styleUrls: ['./switch-pos-order.component.scss']
})
export class SwitchPosOrderComponent implements OnInit {
  selectedTable: Pos | null = null; // Holds the selected table
  filterValue: string = ''; // User input for filtering
  filteredTables: Pos[] = []; // Filtered list of pos-list
  public loading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<SwitchPosOrderComponent>,
    private posService: PosService,
    private _matDialog: MatDialog,
    private toastr: ToastrService,
    private translocoService: TranslocoService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      table: any;
      tables: Pos[];
    }
  ) {}

  ngOnInit(): void {
    this.filteredTables = this.data.tables.filter(table => table.id !== this.data.table?.id); // Initialize filtered pos-list
  }

  // Resets the filtered list when the select is opened
  onSelectOpened(opened: boolean): void {
    if (opened) {
      this.filteredTables = this.data.tables.filter(table => table.id !== this.data.table?.id); // Reset full list when opened
    }
  }

  // Action for cancel button
  onCancel(): void {
    this.dialogRef.close();
  }

  // Action for save button
  onSave(): void {
    this.transferTable(this.data.table, this.data.tables);
  }

  transferTable(pos: Pos, allPos: Pos[]) {
    const user = JSON.parse(localStorage.getItem('user'));
    this.loading = true;
    if (this.selectedTable) {
      this.posService
        .transferTable({
          id_funcionario: user.id_funcionario,
          id_mesa: pos.id,
          id_mesa_transfer: this.selectedTable.id.toString(),
          id_utilizador: user.id_utilizador
        })
        .subscribe(response => {
          this.loading = false;
          this.dialogRef.close(this.selectedTable);
          if (response.status === 0) {
            // Error scenario
            this.translocoService.selectTranslate('messages.error.transfer_failed').subscribe((translatedMessage: string) => {
              this.toastr.error(translatedMessage);
            });
          }
        });
    }
  }
}
